import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as variablesBuilder from '../../../variables-builder'
import * as errorMessage from '../../error-message'

import * as generalTab from './general-tab'

/**
 * Modal used for creating and editing Admin Center apps.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    variablesBuilder.Component,
    generalTab.Component,
    errorMessage.Component,
  ],
  selector: 'atn-admin-app-modal',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.apps.Collection} */
  public readonly appsEc = ngCore.inject(state.admin.apps.Collection)

  /**
   * Shows dialog title based on {@link isNew}
   */
  public readonly titleSg = ngCore.computed(
    (
      isNew = this.appsEc.plugins.currentEntityPlugin.feature.selectors
        .isCreating()
        .asSignal(),
    ) => `${isNew ? 'Create' : 'Update'} App`,
  )

  /** Submit changes handler */
  public saveClickHandler(): void {
    this.appsEc.plugins.editingPlugin.feature.actions.submit
      .from('Dialog.SaveButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }

  /** Discard changes handler */
  public cancelClickHandler(): void {
    this.appsEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.CancelButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }
}
